<template>
    <div class="core">
       <div class="layui-fluid">
          <pub-search :search-type="'add'" :tableObj="tableObj" :searchConfig="searchConfig" exportTemplate="签到签退表.xlsx">
            <template>
                <layui-exportexcel template-name = "签到签退表.xlsx" ref="export">
                    <template slot-scope="{scope}">
                        <button class="layui-btn layuiadmin-btn-role" @click="scope.export(tableObj)"><i class="layui-icon">&#xe67d;</i>导出</button>
                    </template>
                </layui-exportexcel>
            </template>
          </pub-search>
                <layui-table
                  ref="signInOutTable"
                  table-name="YW_SERVICE_ORDER_V1"
                  :renderRow="renderRow"
                  :page-size="20"
                  :page-range="6"
                  :page-options="[10, 20, 50, 100]"
                  :skin="'line'"
                  :defaultCondition="{'SERVICE_STATE:3': '2', 'SERVICE_DELETED:10': '1'}"
                  :sort="['SIGNIN_TIME:DESC']"
                  @table-event-detail="detail($event)"
                >
                  <div>
                      <div checkbox="true" align="center" fixed="left" width="60"></div>
                      <!-- <div title="序号" width="60" field="_NUMBER" align="center" fixed="left"></div> -->
                      <layui-tableconfig :config = "tableList"></layui-tableconfig>
                      <div rowspan="3" align="center" fixed="right" title="操作" width="90">
                          <script type="text/html" v-pre>
                              <a class="layui-btn-xs" lay-event="detail">查看</a>
                          </script>
                      </div>
                  </div>
              </layui-table>
        </div>
        <sign-in-out-form v-if="serviceForm" :visible.sync="serviceForm" :formData="formData"/>
    </div>
</template>
<script>
import "../../../utils/map/css/core.css"
import signInOutForm from './signInOutForm'

export default {
  name: 'signInOut',
  components: {
   signInOutForm
  },
  data () {
    return {
      tableObj: {
          checkedRows: 0,
          queryObject: {}
      },
      tableList:[
          { field: 'SERVICE_ORDER_NUM', title: '服务单编号', width:200},
          { field: 'WORK_ORDER_NUM', title: '服务请求单编号', width:150},
          { field: 'WORK_ORDER_CATEGORY_DESC', title: '服务请求类型', width:150},
          { field: 'CLIENT_NAME', title: '客户', width:200},
          { field: 'BRAND_NAME', title: '品牌', width:150},
          { field: 'STORE_NAME', title: '门店', width:200 },
          { field: 'ENGINEER_NAME', title: '工程师', width:120},
          { field: 'SIGNIN_EXCEPTION', title: '签到异常', width: 100},
          { field: 'SIGNIN_EXCEPTION_REASON', title: '签到异常原因', width: 180},
          { field: 'SIGNIN_LOCATION', title: '签到坐标', width: 200},
          { field: 'SIGNIN_ADDRESS', title: '签到地址', width: 200},
          { field: 'SIGNIN_TIME', title: '签到时间', width: 200},
          { field: 'SIGNOUT_EXCEPTION', title: '签退异常', width: 100},
          { field: 'SIGNOUT_EXCEPTION_REASON', title: '签退异常原因', width: 180},
          { field: 'SIGNOUT_LOCATION', title: '签退坐标', width: 200},
          { field: 'SIGNOUT_ADDRESS', title: '签退地址', width: 200},
          { field: 'SIGNOUT_TIME', title: '签退时间', width:200},
      ],
      searchConfig: {
          basic: [
            {
              TYPE: 'input',
              WIDTH: 260,
              FIELD:
                'SERVICE_ORDER_NUM:2,WORK_ORDER_NUM:2,ENGINEER_NAME:2',
              PLACEHOLDER: '请输入查询条件'
            }
          ],
          advanced: [
            { TYPE:'layui-multiselect', NAME: '服务请求类型:', FIELD: 'WORK_ORDER_CATEGORY:1',textField: 'text', valueField: 'value',initData:this.dict.getData('WORK_ORDER_CATEGORY'),},
            { TYPE:'layui-multiselect', NAME: '是否异常单:', FIELD: 'SIGNIN_EXCEPTION:1',textField: 'text', valueField: 'value',initData:this.dict.getData('SIGNIN_EXCEPTION'),},
            { TYPE:'input', NAME: '服务单编号 :', FIELD:'SERVICE_ORDER_NUM:2', PLACEHOLDER: '请输入查询条件'},
            { TYPE:'input', NAME: '服务请求单编号 :', FIELD:'WORK_ORDER_NUM:2', PLACEHOLDER: '请输入查询条件'},
            { TYPE:'input', NAME: '工程师 :', FIELD:'ENGINEER_NAME:2', PLACEHOLDER: '请输入查询条件'},
          ]
      },
      serviceForm: false,
      formData: null
    }
  },
  mounted(){
    this.tableObj = this.$refs.signInOutTable;
  },
  methods: {
    /**
     * 查看
     */
    detail(params){
      var componentName = 'signInOutForm-' + params.data["SERVICE_ORDER_NUM"];
      this.baseComponent.smartLoadComponent('signInOutForm', {title: '详情-' + params.data['SERVICE_ORDER_NUM'], source: 'workOrder', formData: params.data}, {uniqueName: componentName});
    },
    renderRow(data){
      if(data.SIGNIN_LOCATION == ','){
        data.SIGNIN_LOCATION = '';
      }
      if(data.SIGNOUT_LOCATION == ','){
        data.SIGNOUT_LOCATION = '';
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/workOrder/signInOut/index.vue